import React from "react";
//icons
import {
    AiOutlineBarChart,
    AiOutlineTwitter,
} from "react-icons/ai";
//components
import AeroButton from "../../../components/aeroButton/index";
//images
import msnLogo from "./assets/msn-logo.png";
import { Container } from "./styles";

const sidebar = () => {
    return (
        <Container>
            <AeroButton className="button">
                <img src={msnLogo} alt="" />
            </AeroButton>
            <AeroButton className="button">
                <a href="http://www.x.com/SolanaMessenger" target="_blank">
                    <AiOutlineTwitter size="30" color="#26A7DE" />
                </a>
            </AeroButton>
            <AeroButton className="button">
                <a href="http://www.dexscreener.com/solana/5R5cK7Q87r2TaCzfgzi5jvLK6J5W57sYuJzWLUoLpump" target="_blank">
                    <AiOutlineBarChart size="30" color="black" />
                </a>
            </AeroButton>
        </Container>
    );
};

export default sidebar;
